module.exports = __webpack_public_path__ + "img/bank-089.6efb8636.png";